import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import "./Navbar.css";
import logo from "../../assets/egram-logo.png";

const NAV_ITEMS = [
  { to: "/", label: "मुख्यपृष्ठ" },
  { to: "/notices", label: "सूचना" },
  { to: "/services", label: "सेवा" },
  { to: "/schemes", label: "योजना" },
  { to: "/development", label: "विकास कामे" },
  { to: "/gallery", label: "छायाचित्रे" },
  { to: "/about", label: "गावाची माहिती" },
  { to: "/contact", label: "सदस्य" },
];

const M_MONTHS = ["जाने", "फेब्रु", "मार्च", "एप्रिल", "मे", "जून", "जुलै", "ऑग", "सप्टें", "ऑक्टो", "नोव्हें", "डिसें"];
const M_DAYS = ["रविवार", "सोमवार", "मंगळवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार"];

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "unset";
    return () => { document.body.style.overflow = "unset"; };
  }, [menuOpen]);

  const now = new Date();
  const today = `${M_DAYS[now.getDay()]}, ${now.getDate()} ${M_MONTHS[now.getMonth()]} ${now.getFullYear()}`;

  const isActive = (path) => location.pathname === path;
  const closeMenu = () => setMenuOpen(false);

  const handleLogout = () => {
    logout();
    closeMenu();
    navigate("/login");
  };

  return (
    <>
      {/* tricolor accent */}
      <div style={{ height: 4, display: "flex" }}>
        <div style={{ flex: 1, background: "#FF9933" }} />
        <div style={{ flex: 1, background: "#ffffff" }} />
        <div style={{ flex: 1, background: "#138808" }} />
      </div>

      {/* top utility bar */}
      <div style={{ background: "#0F5C2E", color: "#dcefe0", fontSize: 13.5 }}>
        <div className="rk-topbar-inner">
          <div style={{ display: "flex", gap: 20, alignItems: "center", flexWrap: "wrap" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8fd39a" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
              टोल फ्री : १८००-१२३-४५६७
            </span>
            <span className="rk-topbar-place" style={{ opacity: 0.85 }}>तालुका : 
वरूड &nbsp;·&nbsp; जिल्हा : अमरावती</span>
          </div>
          <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
            <span style={{ opacity: 0.85 }}>{today}</span>
            <span style={{ opacity: 0.4 }}>|</span>
            <span style={{ background: "#ffffff22", border: "1px solid #ffffff33", borderRadius: 5, padding: "2px 9px", fontWeight: 600 }}>मराठी</span>
          </div>
        </div>
      </div>

      {/* header */}
      <header className="rk-header">
        <div className="rk-header-inner">
          <Link to="/" className="rk-brand" onClick={closeMenu}>
            <img src={logo} alt="रोषणखेडा ग्रामपंचायत" className="rk-brand-logo" />
            <div className="rk-brand-text">
              <div style={{ fontFamily: "var(--rk-serif)", fontWeight: 700, fontSize: 17, color: "#0F5C2E", lineHeight: 1.4, whiteSpace: "nowrap" }}>ग्रामपंचायत रोषणखेडा</div>
              <div style={{ fontSize: 12, color: "#5B6B60", letterSpacing: ".3px", lineHeight: 1.4 }}>अधिकृत डिजिटल पोर्टल</div>
            </div>
          </Link>

          <nav className="rk-desktop-nav">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rk-nav-link ${isActive(item.to) ? "active" : ""}`}
              >
                {item.label}
              </Link>
            ))}
            {!user ? (
              <button className="rk-login-btn" onClick={() => navigate("/login")}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
                लॉगिन
              </button>
            ) : (
              <button className="rk-profile-btn" onClick={() => navigate("/profile")}>
                <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="प्रोफाइल" />
                <span>{user.fullName}</span>
              </button>
            )}
          </nav>

          <button className="rk-menu-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label="मेनू">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" d={menuOpen ? "M6 6l12 12M6 18L18 6" : "M4 7h16M4 12h16M4 17h16"} /></svg>
          </button>
        </div>

        {/* mobile menu */}
        {menuOpen && (
          <div className="rk-mobile-menu">
            {user && (
              <button className="rk-mobile-profile" onClick={() => { navigate("/profile"); closeMenu(); }}>
                <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" alt="प्रोफाइल" />
                <span>स्वागत आहे, {user.fullName}</span>
              </button>
            )}
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={closeMenu}
                className={`rk-mobile-link ${isActive(item.to) ? "active" : ""}`}
              >
                {item.label}
              </Link>
            ))}
            {!user ? (
              <button className="rk-login-btn rk-mobile-login" onClick={() => { navigate("/login"); closeMenu(); }}>लॉगिन</button>
            ) : (
              <button className="rk-mobile-logout" onClick={handleLogout}>लॉगआउट</button>
            )}
          </div>
        )}
      </header>
    </>
  );
};

export default Navbar;
